import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Payment } from "../interfaces/common/signUp";

@Injectable()
export class PaymentValuesExtractor
{
    private _payment: Payment = new Payment();

    newCard(cardDetailsForm:FormGroup): PaymentValuesExtractor
    {
        this._payment.cardHolderName = cardDetailsForm.get('name').value;
        this._payment.saveCardDetails = cardDetailsForm.get('saveCardDetails').value;
        this._payment.cardDescription = cardDetailsForm.get('cardDescription').value;

        return this;
    }

    existingCard(cardId: number): PaymentValuesExtractor {

        this._payment.cardId = cardId;

        return this;
    }

    paymentValues(topUpForm:FormGroup) : PaymentValuesExtractor {
        this._payment.topUpAmount = topUpForm.get('amount').value;
        this._payment.amountToPay = topUpForm.get('amount').value;
        this._payment.createAutoTopUp = topUpForm.get('isAutoTopUp').value;
        
        return this;
    }

    getPayment(): Payment {
        let payment = new Payment(); 
        
        payment.cardId = this._payment.cardId;
        payment.cardHolderName = this._payment.cardHolderName;
        payment.topUpAmount = this._payment.topUpAmount;
        payment.amountToPay = this._payment.amountToPay;
        payment.saveCardDetails = this._payment.saveCardDetails;
        payment.createAutoTopUp = this._payment.createAutoTopUp;
        payment.cardDescription = this._payment.cardDescription;

        this._payment = new Payment();

        return payment;
    }
}